// 获获取拣货单信息
export const getPickingInfo = params => {
  return window._this.$http.get(`/erp/DeliveryCheck/getPickingInfo`, params);
};
// 获获取拣货单信息
export const getCheckData = params => {
  return window._this.$http.post(`/erp/DeliveryCheck/getCheckData`, params);
};

// 校验
export const check = params => {
  return window._this.$http.post(`/erp/DeliveryCheck/check`, params);
};

// 完成校验
export const finishCheck = params => {
  return window._this.$http.post(`/erp/DeliveryCheck/finishCheck`, params);
};

// 退出校验
export const exitCheck = params => {
  return window._this.$http.post(`/erp/DeliveryCheck/exitCheck`, params);
};



// WEBPACK FOOTER //
// ./src/api/goodsInspection.js